// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueClipboard  from 'vue-clipboard2'
import Vant from 'vant';
import 'vant/lib/index.css';
import wx from 'weixin-js-sdk'//微信分享sdk
import { wechatShare,wechatScanQRCode,wechatGetLocation } from './utils/wxConfig'
Vue.prototype.wechatShare  = wechatShare;
Vue.prototype.wechatScanQRCode  = wechatScanQRCode;
Vue.prototype.wechatGetLocation  = wechatGetLocation;
Vue.prototype.wx  = wx;

Vue.use( Vant );
Vue.use( VueClipboard );
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js